import { ApiError, apiFetch } from "../../../lib/api/client";
import { createIdempotencyKey } from "../../../lib/api/idempotency";
import {
  receiptSchema,
  submissionDetailSchema,
  type SubmissionAnswerInput,
} from "../schemas/questionnaireSchemas";

function requestBody(answers: SubmissionAnswerInput[], namedNoticeAccepted: true) {
  return JSON.stringify({ namedNoticeAccepted, answers });
}

export async function getCurrentQuestionnaireSubmission() {
  try {
    return submissionDetailSchema.parse(
      await apiFetch<unknown>("/questionnaire/submissions/current"),
    );
  } catch (error) {
    if (
      error instanceof ApiError &&
      error.problem.code === "QUESTIONNAIRE_SUBMISSION_NOT_FOUND"
    ) {
      return null;
    }
    throw error;
  }
}

export async function submitQuestionnaire(
  answers: SubmissionAnswerInput[],
  namedNoticeAccepted: true,
) {
  const key = `questionnaire-${createIdempotencyKey()}`;
  return receiptSchema.parse(
    await apiFetch<unknown>("/questionnaire/submissions", {
      method: "POST",
      headers: { "Idempotency-Key": key },
      body: requestBody(answers, namedNoticeAccepted),
    }),
  );
}

export async function updateCurrentQuestionnaireSubmission(
  answers: SubmissionAnswerInput[],
  namedNoticeAccepted: true,
) {
  return receiptSchema.parse(
    await apiFetch<unknown>("/questionnaire/submissions/current", {
      method: "PUT",
      body: requestBody(answers, namedNoticeAccepted),
    }),
  );
}
